export enum Email {
  GMAIL = "gmail",
  YAHOO = "yahoo",
  LIVE = "live",
  OUTLOOK = "outlook",
}

export enum Layout {
  GRID = "grid",
  LIST = "list",
}

export enum ValueType {
  TEXT = "TEXT",
  YES_NO = "YES_NO",
  WHOLE_NUMBER = "WHOLE_NUMBER",
  DECIMAL_NUMBER = "DECIMAL_NUMBER",
  PHONE = "PHONE",
  EMAIL = "EMAIL",
  DATE = "DATE",
}

export enum MomentDateFormat {
  YYYY_MM_DD = "YYYY/MM/DD",
  LLL = "LLL",
}

export enum OperationType {
  ADD = "ADD",
  EDIT= "EDIT"
}
